import { Card, Row, Col, InputGroup, Form, ButtonGroup, Button } from 'react-bootstrap';
import { FaSearch, FaFilter } from 'react-icons/fa';

// filters = [{ value, label, variant }]
// Ex: [{ value: 'ALL', label: 'Todos', variant: 'dark' }, ...]
export function SearchFilterBar({
  searchTerm,
  onSearchChange,
  searchPlaceholder = 'Buscar...',
  filters,
  activeFilter,
  onFilterChange,
  children // slot para filtros extras
}) {
  return (
    <Card className="mb-4 shadow-sm">
      <Card.Body>
        <Row className="align-items-center gap-3 gap-md-0">
          <Col md={7}>
            <InputGroup>
              <InputGroup.Text><FaSearch /></InputGroup.Text>
              <Form.Control
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
              />
            </InputGroup>
          </Col>

          {filters && (
            <Col md={5} className="d-flex justify-content-md-end align-items-center">
              <span className="text-muted me-2 small fw-bold d-none d-lg-block">
                <FaFilter className="me-1" /> Filtros:
              </span>
              <ButtonGroup size="sm">
                {filters.map(({ value, label, variant }) => (
                  <Button
                    key={value}
                    variant={activeFilter === value ? variant : `outline-${variant}`}
                    onClick={() => onFilterChange(value)}
                  >
                    {label}
                  </Button>
                ))}
              </ButtonGroup>
            </Col>
          )}

          {children}
        </Row>
      </Card.Body>
    </Card>
  );
}
